/**
 * Route Controller for handling route based navigation
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseRouterController = require("controllers/BaseRouterController");
    var AutomationRouteController = {};

    LE.module("LEAutomation", function (LEAutomation, LE, Backbone, Marionette, $, _) {
        AutomationRouteController = BaseRouterController.extend({
            navigation: {
                routes: {
                    '*path': {
                        name: 'defaultRoute',
                        callback: 'showLandingPage',
                    },
                    "landing-page": {
                        callback: "showLandingPage",
                        name: "landingPage",
                    },
                    "conversation": {
                        callback: "showConvBuilder",
                        name: "conversationBuilder",
                    },
                    "bot-platform": {
                        callback: "showBotplatform",
                        name: "botplatform",
                    },
                },
                defaultRoute: "landing"
            },
            routeHandler: function () {
                LEAutomation.logger.dir(arguments, "--------------routeHandler fired with the arguments---------------------");
            },
            showLandingPage: function () {
                LEAutomation.vent.trigger("router:show-landing-page");
            },
            showConvBuilder: function () {
                LEAutomation.vent.trigger("router:show-conv-builder");
            },
            showBotplatform: function () {
                LEAutomation.vent.trigger("router:show-bot-platform");
            }
        });
    });

    return AutomationRouteController;
});
